module.exports = __webpack_public_path__ + "static/map-b60a8e6070058d281ed74e319ed5ae5d.png";